export default __webpack_public_path__ + "static/media/slideaccesorio3.bf1f070c.png";